import type { InvalidReason } from '../types';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import Shell from './ui/Shell';

interface ExpiredScreenProps {
  reason: InvalidReason;
}

const REASON_COPY: Record<InvalidReason, { title: string; body: string }> = {
  expired: {
    title: 'This interview link has expired',
    body: 'The link your recruiter shared is no longer valid. Please reach out to them and ask for a fresh invitation.',
  },
  unknown: {
    title: "We couldn't find this interview",
    body: 'This link may be malformed or already removed. Please double-check the URL your recruiter sent you, or ask for a new one.',
  },
  completed: {
    title: 'This interview is already complete',
    body: 'Thank you — your answers have been recorded. You do not need to do anything else.',
  },
};

export default function ExpiredScreen({ reason }: ExpiredScreenProps) {
  const { title, body } = REASON_COPY[reason];
  return (
    <Shell centered maxWidth="narrow">
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{body}</p>
        </CardContent>
      </Card>
    </Shell>
  );
}
